import classnames from 'classnames';
import React from 'react';

import { Button } from '../button/Button';
import { collapseRange } from './collapseRange';
import styles from './Pagination.module.scss';

export interface PaginationProps {
  pages: string[];
  activeIndex: number;
  onClick: (index: number) => void;
  maxItems?: number;
  className?: string;
}

export const Pagination = ({
  pages,
  activeIndex,
  className,
  maxItems = 7,
  onClick,
}: PaginationProps) => {
  const handlePrevious = () => {
    if (activeIndex !== 0) {
      onClick(activeIndex - 1);
    }
  };

  const handleNext = () => {
    if (activeIndex !== pages.length - 1) {
      onClick(activeIndex + 1);
    }
  };

  return (
    <div
      data-testid="pagination"
      className={classnames(styles.root, className)}
    >
      <div className={styles.group}>
        <Button
          iconName="ChevronBoldLeft"
          size="small"
          variant="empty"
          onClick={handlePrevious}
          data-testid="button-previous-pagination"
        />
        {collapseRange({
          pages,
          current: activeIndex,
          max: maxItems,
          ellipsis: () => <span>...</span>,
          transform: (page: string, currPageIndex: number) => {
            const isActive = currPageIndex === activeIndex;

            return (
              <Button
                key={page}
                size="small"
                variant="empty"
                label={page}
                onClick={() => onClick(currPageIndex)}
                className={classnames(
                  isActive && styles.buttonActive,
                  styles.buttonDisabled
                )}
                data-testid="button-pagination"
              />
            );
          },
        })}
        <Button
          iconName="ChevronBoldRight"
          size="small"
          variant="empty"
          onClick={handleNext}
          data-testid="button-next-pagination"
        />
      </div>
    </div>
  );
};
